import { fabric } from 'fabric';

export default function addCanvasObjectsFromJSON(json) {
  const vCanvas = new fabric.Canvas();

  const isSameCanvas = window.editorLoader.canvasId === json.canvasId;
  delete json.canvasId;

  vCanvas.loadFromJSON(json, () => {
    vCanvas.forEachObject((obj) => {
      if (isSameCanvas) {
        obj.set({
          top: obj.top + 10,
          left: obj.left + 10,
        });
      }

      window.canvas.add(obj);
    });

    window.canvas.renderAll();
  });
}
